<div class="header">
  <span class="header__name">{{ name }}</span>
  <span
    class="header__count"
    matBadgeSize="small"
    matBadgeColor="warn"
    [matBadgeHidden]="changeCount === 0"
    [matBadge]="changeCount"
  >
    <ts-loading-attribute [value]="loading ? undefined : (count | compactNumber)"></ts-loading-attribute>
  </span>
  <span class="header__pct">
    <ts-loading-attribute [value]="loading ? undefined : (percentage | number : '1.0-1') + '%'"></ts-loading-attribute>
  </span>
</div>
